/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { Card, CardContent } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Button } from "../../../shared/widgets";
import SettlementModal from "./SettlementModal";
import { MessageType } from "../../../Constant";
import GridList from "../collection/GridList";
import { setNotificationMessage } from "../../../redux/actions/notificationAction";
import { getBulkSettlementProcessStatusService } from "../../../services/settlementService";
import "./settlementGrid.css";
import { commonStyle } from "./commonStyles";
import CommonCardContent from "./CommonCardContent";

const styles = commonStyle;

class SettlementCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      isUpdated: false,
      processingMsg: false,
      isSettlementProcessing: false,
    };
  }

  componentDidMount() {
    this.getSettlementProcessStatus();
  }

  getSettlementProcessStatus = () => {
    const { operatorId, cityId } = this.props;
    getBulkSettlementProcessStatusService({
      "settlement.operatorId": Number(operatorId),
      "settlement.cityId": String(cityId),
    }).then((res) => {
      if (res.unProcessedSettlements && res.unProcessedSettlements.length) {
        const isProcessing = res.unProcessedSettlements.find(
          (s) => s.settlement.cityId === cityId && s.settlement.operatorId === operatorId,
        );
        this.setState({
          isSettlementProcessing: !!isProcessing,
        });
      }
    });
  };

  showSettlementModal = () => {
    this.setState({
      showModal: true,
    });
  };

  messageCallBack = (type, msg) => {
    const { isUpdated, initiateNotification } = this.props;
    if (type) {
      if (type === MessageType.SUCCESS) {
        isUpdated();
      }
      initiateNotification({
        type,
        message: msg,
      });
    }
    if (type !== MessageType.ERROR) {
      this.setState({
        showModal: false,
        processingMsg: false,
      });
    }
  };

  processingData = (data) => {
    data === "start" ? this.setState({ processingMsg: true }) : this.setState({ processingMsg: false });
  };

  displayModal() {
    const { data, location, currentDueVehicles } = this.props;
    const { showModal, selected, steps } = this.state;
    return (
      <SettlementModal
        data={data}
        showModal={showModal}
        vehicleDetails={location.state || {}}
        selectedVehicle={selected}
        currentDueVehicles={currentDueVehicles}
        steps={steps}
        showSettlementModal={this.showSettlementModal}
        messageCallBack={(type, msg) => { this.messageCallBack(type, msg); }}
        // eslint-disable-next-line no-shadow
        processingData={(d) => this.processingData(d)}
      />
    );
  }

  render() {
    const {
      classes, isSettlementRunning, data, gridStrings, user, isLoading,
    } = this.props;
    const { isSettlementProcessing, processingMsg, showModal } = this.state;

    if (user && user.role && user.role === "Operator") {
      // operator role
      return (
        <div className="custom-grid-layout">
          {Object.keys(gridStrings).map((column, index) => (
            <div key={index} className="custom-grid">
              <GridList value={data[column]} isLoading={isLoading} template={column} type="settlementGridItems" />
            </div>
          ))}
        </div>
      );
    }
    return (
      <Card className={[classes.cardWrapper, "settlement-scroll"]}>
        <div className={classes.details}>
          {Object.keys(gridStrings).map((key) => (
            <CommonCardContent
              key={key}
              cardKey={key}
              classes={classes}
              data={data}
              gridStrings={gridStrings}
              isLoading={isLoading}
            />
          ))}

          <CardContent className={classes.cardContentWrapper}>
            <div>
              <Button
                buttonText="Settle Amount"
                onClick={(!isSettlementRunning && !processingMsg) && this.showSettlementModal}
                disable={(isLoading
                  && (isSettlementRunning || processingMsg)) || isSettlementProcessing}
              />
              {(isSettlementRunning || processingMsg || isSettlementProcessing)
                    && (
                      <div className={classes.processing}>
                        <span>
                          Settlement in progress...
                        </span>
                      </div>
                    )}
            </div>
          </CardContent>
        </div>
        {showModal && this.displayModal()}
      </Card>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.Auth.user,
    isSettlementRunning: state?.Settlement?.settlementSummary?.isSettlementRunning,
  };
}

const mapDispatchToProps = (dispatch) => ({
  initiateNotification: (value) => {
    dispatch(setNotificationMessage(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withRouter(SettlementCard)));
